// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"15256dd7","246":"66da3a77","453":"8e9e3179"}[chunkId] + ".chunk.js";
};